export const API_KEY = "ae7d4af255a05506e1ed3b49e48b0d5c";
export const ApiPopularMovies = "https://api.themoviedb.org/3/movie/popular";
export const ApiPopularPeople = "https://api.themoviedb.org/3/person/popular";
export const API_URL = "https://api.themoviedb.org/3";
export const IMG_URL = "https://image.tmdb.org/t/p/w500/";
export const searchAPI = "https://api.themoviedb.org/3/search";
export const movieID = "https://api.themoviedb.org/3/movie/";
export const apiGenres = "https://api.themoviedb.org/3/genre/movie/list";
export const apiMovieDetails = "movie/";
export const imgBaseBackdrop = "https://image.tmdb.org/t/p/original";
export const details = "https://api.themoviedb.org/3/movie/{movie_id}";